import React, { useState, useEffect, useRef } from 'react';

//Components.
import ActiveChallengeFormInputs from './active-challenge-end-formInput/ActiveChallengeFormInputs';

//Dependencies.
import { v4 } from 'uuid';
import { motion } from 'framer-motion';
import { useNavigate, useParams } from 'react-router-dom';

//Functions.
  //Slices.
  import { useDispatch, useSelector } from 'react-redux';
  //Slices - action creators.
  import { addActiveChallenge, addActiveChallengeThunk, addUpcomingChallengeToFSandReduxThunk } from '../../../slices/challengesSlice';
  //Callbacks.
  import { loggedInUser } from '../../../slices/allUsersSlice';
  import { allVideos } from '../../../slices/allVideosSlice';
  //Other functions.
  import { calculateDaysRemaining } from '../../../functions/momentJS';
  
//Components.
import VideoCardComponent from '../../card-component/video-card-component/VideoCardComponent';
import ChallengeAnnouncementInputs from './challenge-announcement-formInput/ChallengeAnnouncementInputs';

//Dependencies.
import { Alert, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import "./ChallengeForm.styles.css";


const ChallengeForm = () => {
  const [activateAlerts, setActivateAlerts] = useState({ challengeVideo: false });
  const [challengeAnnouncementDetails, setChallengeAnnouncementDetails] = useState(
    {
      addChallengeAnnouncement: null,
      challengeAnnouncementHeadline: '',
      challengeAnnouncementEndDate: null,
      daysRemainingBeforeAnnouncementEnds: 0
    }
  );

  const [challengeEndConditions, setchallengeEndConditions] = useState({ challengeEndsWhen: null });
  const [challengeVideos, setChallengeVideos] = useState({});
  const [coverImageDetails, setCoverImageDetails] = useState({ source: null, imageLink: null });

  const currentUser = useSelector(loggedInUser);
  const videos = useSelector(allVideos);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const params = useParams();

  const activeChallengeEndDateRef = useRef();
  const descriptionRef = useRef();
  const imageFileRef = useRef();  
  const titleRef = useRef();  
  const winningVotesRef = useRef();

  useEffect(() => {
    return () => {
      setchallengeEndConditions({ challengeEndsWhen: null });
      setChallengeVideos({});
      setCoverImageDetails({ source: null });
    }
  }, []);

  const handleChallengeSubmission = async (e) => {
    e.preventDefault();

    setActivateAlerts(prvActivateAlerts => ({ ...prvActivateAlerts, challengeVideo: false }));

    if (Object.values(challengeVideos) < 1) {
      e.target.reset();
      setActivateAlerts(prvActivateAlerts => ({ ...prvActivateAlerts, challengeVideo: true }));

      return;
    }

    const _challengeID = `challenge-${v4()}`;

    const challengeObject = {
      _challengeID,
      _ownerID: currentUser._userID,
      challengeVideos,
      coverImageDetails: {
        ...coverImageDetails,
        imageLink:
          coverImageDetails.imageLink ?
            coverImageDetails.imageLink
            :
            imageFileRef.current.value
      },
      activeChallengeProperties: {
        title: titleRef.current.value,
        description: descriptionRef.current.value,
        howWillActiveChallengeEnd: challengeEndConditions.challengeEndsWhen,
        activeChallengeComments: [],
        voters: [], //each element is inputted as _userID.
        winningVotes: winningVotesRef.current ?
          winningVotesRef.current.value
          :
          null,
        winner: {},
        endActiveChallenge: false,
        activeChallengeEndDate: activeChallengeEndDateRef.current ?
          activeChallengeEndDateRef.current.value
          :
          null,
        activeChallengeDaysRemaining: activeChallengeEndDateRef.current ?
          calculateDaysRemaining(activeChallengeEndDateRef.current.value)
          :
          false,
        voteTracker: Object.values(challengeVideos).map(val => ({ ...val, votes: 0, isLeading: false })) //counter to keep track of votes for each video so you can see which video is leading and ultimately wins.
      },
      upcomingChallengeProperties: { ...challengeAnnouncementDetails }
    }

    if (challengeAnnouncementDetails.addChallengeAnnouncement) {
      await dispatch(addUpcomingChallengeToFSandReduxThunk({ ...challengeObject }));
      navigate("/challenges/announcements/all");
    }
    else {
      await dispatch(addActiveChallengeThunk({ ...challengeObject })); 
      navigate("/challenges/actives/all");
    }

    e.target.reset();
  }

  return (
    <Form style={{
      padding: "1.5%",
      margin: "5%",
      paddingTop: "1.5%",
      paddingBottom: "1.5%",
      border: "3.5px solid red",
      backgroundColor: "rgba(245, 245, 245, 1)",
      borderRadius: "15px",
      minWidth: "50%",
      minHeight: '100%'
    }} onSubmit={handleChallengeSubmission}>

      <FormGroup>
        <Label htmlFor='title'><strong>TITLE.</strong></Label>
        <Input type='text' id='title' placeholder='Challenge Title' required style={{border: '1.75px solid black'}} defaultValue="My Test Challenge." innerRef={titleRef}/>
      </FormGroup>

      <FormGroup style={{backgroundColor: "bisque", margin: '0.5%', padding: '1.5%', borderRadius: '15px'}}>
        <Label htmlFor='image'><strong>YOUR CHALLENGE NEEDS A <em>CHALLENGE COVER IMAGE</em>. WHERE WILL YOU GET THAT IMAGE FROM?</strong></Label>
        <Row>
          <Col sm={5}>computer (via download):</Col>
          <Col sm={7}>
            {" "}
            <Input type='radio' name="coverImageDetails" value="computer" style={{border: "3px solid black"}} onChange={e => setCoverImageDetails(prvCoverImageDetails => ({...prvCoverImageDetails, source: e.target.value}))} required />
          </Col>
        </Row>
        <Row>
          <Col sm={5}>online (copy/paste copyright-free url)</Col>
          <Col sm={7}>
            {" "}
            <Input type="radio" name="coverImageDetails" value="online url" style={{border: "3px solid black"}} onChange={e => setCoverImageDetails(prvCoverImageDetails => ({...prvCoverImageDetails, source: e.target.value}))} />
          </Col>
        </Row>
      </FormGroup> {/* challenge image source. */}

      {
        (coverImageDetails.source === "computer") //image via download.
        &&
        <FormGroup style={{backgroundColor: "blanchedalmond", margin: '0.5%', padding: '1.5%', borderRadius: '15px'}}>
          <Label htmlFor='downloadImg'><strong>DOWNLOAD YOUR IMAGE:</strong></Label>
          <Input type='file' id='downloadImg' style={{border: '3px solid black'}} onChange={ e => setCoverImageDetails({...coverImageDetails, imageLink: e.target.files[0]}) } required />
        </FormGroup>
      }

      {
        (coverImageDetails.source === "online url") //image via url.
        &&
        <FormGroup style={{backgroundColor: "blanchedalmond", margin: '0.5%', padding: '1.5%', borderRadius: '15px'}}>
            <Label html="onlineImg"><strong>COPY/PASTE ONLINE <em>IMAGE URL</em> BELOW.</strong></Label>
            <Input type='text' id="onlineImg" defaultValue="https://st2.depositphotos.com/1000409/10599/i/450/depositphotos_105996322-stock-photo-night-forest-illustration.jpg" style={{border: '3px solid black'}} innerRef={imageFileRef} required />
        </FormGroup>
      }

      <FormGroup>
        <Label htmlFor='description'><strong>CHALLENGE DESCRIPTION.</strong></Label>
        <Input type='textarea' id='description' placeholder='Your description here (optional)' style={{border: '3px solid black'}} innerRef={descriptionRef} />
      </FormGroup> { /* challenge description. */ }
      
      {
        activateAlerts.challengeVideo && <Alert color='danger'><h5 style={{textAlign: 'center'}}>PLEASE SELECT AT LEAST  <em>ONE VIDEO</em> FOR YOUR CHALLENGE!!!</h5></Alert> //alert to select at least one video.
      }

      <FormGroup>
        <div className='videosGridContainer'>
          {
            Object.values(videos)
              .filter(val => val._userID === currentUser._userID)
              .map(video => {
                return (
                  <div key={video._videoID} style={{maxWidth: '100%', display: 'flex', justifyContent: 'center'}} className='my-5 p-1'>
                    <VideoCardComponent {...video} challengeVideos={challengeVideos} setChallengeVideos={setChallengeVideos} />
                  </div>
                )
              })
          }
        </div>        
      </FormGroup> {/* select videos. */}

      <FormGroup style={{backgroundColor: "bisque", margin: '0.5%', padding: '1.5%', borderRadius: '15px'}}>
        <Label><strong>WOULD YOU LIKE TO ADD AN ANNOUNCEMENT/INVITATION FOR OTHERS TO SEE BEFORE YOU START THE CHALLENGE?</strong></Label>
        <Row>
          <Col sm={5}>Yes, add an announcement/notification.</Col>
          <Col sm={7}>
            <Input type="radio" name="add-announcement" value="yes" required onChange={e => setChallengeAnnouncementDetails(prvDetails => ({...prvDetails, addChallengeAnnouncement: e.target.value === "yes" ? true : false}))} />
          </Col>
        </Row>        
        <Row>
          <Col sm={5}>No. Start the challenge right away.</Col>
          <Col sm={7}>
            <Input type="radio" name="add-announcement" value="no" onChange={e => {
              setChallengeAnnouncementDetails(prvDetails => ({...prvDetails, addChallengeAnnouncement: e.target.value === "yes" ? true : false, challengeAnnouncementHeadline: '', challengeAnnouncementEndDate: '', daysRemainingBeforeAnnouncementEnds: 0}))
            }} />
          </Col>
        </Row>        
      </FormGroup> {/*add challenge announcement?*/} 

      {
        (challengeAnnouncementDetails.addChallengeAnnouncement)
        &&
        <ChallengeAnnouncementInputs
          challengeAnnouncementDetails={challengeAnnouncementDetails}
          challengeEndConditions={challengeEndConditions}
          setChallengeAnnouncementDetails={setChallengeAnnouncementDetails} setchallengeEndConditions={setchallengeEndConditions}
          activeChallengeEndDateRef={activeChallengeEndDateRef}
          winningVotesRef={winningVotesRef}
        />
      }

      {
        (challengeAnnouncementDetails.addChallengeAnnouncement === false)
        &&
        <ActiveChallengeFormInputs
          activeChallengeEndDateRef={activeChallengeEndDateRef}
          challengeAnnouncementEndDate={challengeAnnouncementDetails.challengeAnnouncementEndDate}
          challengeEndConditions={challengeEndConditions}
          setchallengeEndConditions={setchallengeEndConditions}
          winningVotesRef={winningVotesRef}
        />
      }

      <div className="d-grid gap-2">
        <button className="btn btn-danger" type="submit">SUBMIT CHALLENGE INFORMATION!!!</button>
      </div>
    </Form>
  )
}

export default ChallengeForm